<template>
  <div v-if="turmas" class="col-xs-12 col-md-3">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="turmas"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from '../../../../domain/corpore/CursoService';
import SwalMessage  from '../../../../domain/message/SwalMessage';

export default {
  name: "c-protocolo-turma-colegio",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    perletivo() {
      return `E${this.$moment().format("YYYY")}`
    }
  },
  asyncComputed: {
    turmas() {
      let curso = this.formValues.cursoId;
      if (curso) {
        const cursoService = new CursoService(this.$http);
        return cursoService
          .getTurmasCurso(curso, this.perletivo)
          .then(result => {
            return result.map(periodo => ({
              value: periodo.CODTURMA,
              text: periodo.TURMA
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TurmaColegio.vue